<template>
    <el-dialog :title="$STR('ws_title_warehouse_statistics_select_warehouse', '选择仓库')" :visible.sync="dialogVisible"  :close-on-click-modal="false"  width="40%" @close="closeWarehouse">
        <div style="display: flex;width: 100%;margin-bottom: 20px" v-if="orgType === 0 || orgType === 3 ">
            <el-select @change="searchWarehouseList" v-if=" selectedRecordId === 1" v-model="statusKey" :placeholder="$STR('ws_title_warehouse_statistics_select_warehouse_all', '全部仓库')" style="width: 150px">
                <el-option
                    v-for="item in statusList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                ></el-option>
            </el-select>
            <div style="display: flex;margin-left: 10px">
                <el-input style="margin-right: 10px" clearable :placeholder="$STR('ws_hint_warehouse_operation_message_enter_operator_code_value_warehouse_Name', '输入仓库名称')" v-model="warehouseKeyString" @keyup.enter.native="searchWarehouseList">
                </el-input>
                <el-button type="primary" plain @click="searchWarehouseList">{{ $STR('COMMON.common.btn.search', '搜索') }}</el-button>
            </div>
        </div>
        <el-table :row-key="getRowKey" :data="warehouseList" highlight-current-row @selection-change="handleWarehouseSelectionChange" ref="warehouseTable" style="overflow-y: auto">
            <el-table-column
                type="selection"
                :reserve-selection="true"
                width="55">
            </el-table-column>
            <el-table-column
                :label="$STR('ws_title_warehouse_statistics_select_warehouse_name', '仓库名称') " :show-overflow-tooltip="true" prop="warehouseName">
            </el-table-column>
            <el-table-column
                :label="$STR('ws_title_warehouse_statistics_select_warehouse_affiliated_org_name', '所属组织')" :show-overflow-tooltip="true" prop="affiliatedOrgName">
            </el-table-column>
        </el-table>
        <el-pagination background @size-change="warehouseHandleSizeChange" @current-change="warehouseHandleCurrentChange" :current-page="warehouseCurrent"
                       :page-sizes="[10, 20, 30, 40]" :page-size="warehouseRows" layout="total, sizes, prev, pager, next, jumper" :total="warehouseCount"> </el-pagination>
        <div class="oper-button">
            <el-button type="" @click="closeWarehouse">{{ $STR('COMMON.common.btn.cancel', '取消') }}</el-button>
            <el-button type="primary" plain @click="userSelectWarehouse">{{ $STR('goods.addGoods.confirm', '确认') }}</el-button>
        </div>
    </el-dialog>
</template>

<script>
export default {
    name: 'warehouseVisible',
    props: ['visible', 'checkList', 'whichOne'],
    computed: {
        dialogVisible: {
            get: function () { return this.visible; },
            set: function () { return; }
        }
    },
    watch: {
        dialogVisible (val) {
            if (!val) return;
            this.resetSearch();
            this.checkedList = this.checkList;
            this.getWarehouseList();
            let userInfo = baseStore.getUserInfo();
            if (userInfo) {
                this.orgType = userInfo.orgType;
            }
        }
    },
    data() {
        return {
            //仓库分页
            warehouseCount: 0,
            warehouseCurrent: 1,
            warehouseRows: 20,
            asc: false,
            warehouseList: [],
            checkedList: [],
            warehouseKeyString: '',
            selectedRecordId: '',
            statusList: [
                {
                    id: '',
                    value: this.$STR('ws_label_script_warehouse_statistics_status_warehouse_all_value', '全部仓库'),
                    name: this.$STR('ws_label_script_warehouse_statistics_status_warehouse_all_name', '全部仓库')
                },
                {
                    id: 0,
                    value: this.$STR('ws_label_script_warehouse_statistics_status_option1_value', '选项1'),
                    name: this.$STR('ws_label_script_warehouse_statistics_status_org_name', '所属企业')
                },
                {
                    id: 2,
                    value: this.$STR('ws_label_script_warehouse_statistics_status_option2_value', '选项2'),
                    name: this.$STR('ws_label_script_warehouse_statistics_status_factory_name', '所属工厂')
                },
                {
                    id: 3,
                    value: this.$STR('ws_label_script_warehouse_statistics_status_option3_value', '选项3'),
                    name: this.$STR('ws_label_script_warehouse_statistics_status_dealer_name', '所属经销商')
                },
                {
                    id: 1,
                    value: '选项4',
                    name: '所属供应商'
                }
            ],
            orgType: '', //0-企业，1-供应商，2-工厂，3-经销商
            statusKey: ''
        };
    },
    created() {
        this.getWarehouseList();
    },
    methods: {
        resetSearch () {
            this.warehouseKeyString = '';
            this.statusKey = '';
        },
        //仓库分页
        warehouseHandleSizeChange(val) {
            this.warehouseRows = val;
            this.getWarehouseList();
        },
        warehouseHandleCurrentChange(val) {
            this.warehouseCurrent = val;
            this.getWarehouseList();
        },
        searchWarehouseList() { //搜索按钮点击
            this.warehouseCurrent = 1;
            this.getWarehouseList();
        },
        getWarehouseList() { //获取仓库列表
            this.selectedRecordId = this.$parent.selectedRecord.id;
            if ( this.selectedRecordId === 1) {
                this.$http.get(WebApi.warehouse.warehouseByPages, {
                    params: {
                        current: this.warehouseCurrent,
                        rows: this.warehouseRows,
                        asc: this.asc,
                        orgType: this.statusKey,
                        keyword: this.warehouseKeyString
                    }
                }).then(_ => {
                    if (_.data.success) {
                        if (_.data.data) {
                            if (_.data.data.records) {
                                this.warehouseList = _.data.data.records;
                            }
                            this.warehouseCount = _.data.data.total;
                        }
                        this.inintData(this.warehouseList);
                    }
                });
            } else {
                this.$http.get(WebApi.warehouse.selectPage, {
                    params: {
                        warehouseName: this.warehouseKeyString
                    }
                }).then(_ => {
                    if (_.data) {
                        this.warehouseList = _.data.rows;
                        this.warehouseCount = _.data.total;
                        this.inintData(this.warehouseList);
                    }
                });
            }
        },
        handleWarehouseSelectionChange (val) {
            this.checkedList = val;
        },
        inintData(list) { //勾选回显
            if (list) {
                list.forEach((row, index) => {
                    this.checkedList.forEach(data => {
                        if (row.id === data.id) {
                            this.$nextTick(() => {
                                this.$refs.warehouseTable.toggleRowSelection(this.$refs.warehouseTable.data[index], true);
                            });
                        }
                    });
                });
            }
        },
        closeWarehouse() {
            this.$parent.warehouseDialogVisible = false;
            this.$parent.warehouseOutDialogVisible = false;
            this.$parent.warehouseInDialogVisible = false;
        },
        userSelectWarehouse() {
            this.$parent.warehouseDialogVisible = false;
            this.$parent.warehouseOutDialogVisible = false;
            this.$parent.warehouseInDialogVisible = false;
            if (this.whichOne === 'in') {
                this.$parent.chosenWarehouseInList = this.checkedList;
            } else if (this.whichOne === 'out') {
                this.$parent.chosenWarehouseOutList = this.checkedList;
            } else {
                this.$parent.chosenWarehouseList = this.checkedList;
            }
        },
        getRowKey(row) {
            return row.id;
        }
    }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/cloud/warehouse/warehouseVisible.vue